<template>
  <div>
    <a-alert>
      <div slot="message" style="text-align: center">
        <!-- <span style="font-weight: bolder"
          >Aim: Select a gene to view network of perturbation similarity:</span
        > -->
        <a-select
          style="width: 80%; margin-left: 10px"
          @search="handleSearch"
          @change="handleChange"
          show-search
          :filter-option="true"
          :value="value"
        >
          <a-select-option v-for="item in options" :key="item" :value="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </div>
    </a-alert>
    <a-row>
      <a-col :span="12" style="margin-top: 20px"
        ><perturbationtable v-bind:selectgene="this.value"
      /></a-col>
      <a-col :span="12"
        ><div style="margin: 10px 10px">
          <img
            slot="cover"
            alt="example"
            height="100%"
            width="100%"
            :src="this.svgSrc"
          /></div
      ></a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import Highcharts from "highcharts";
import networkgraph from "highcharts/modules/networkgraph";
import exporting from "highcharts/modules/exporting";
import accessibility from "highcharts/modules/accessibility";
import oldie from "highcharts/modules/oldie";
import perturbationtable from "./perturbationTable.vue";

networkgraph(Highcharts);
accessibility(Highcharts);
oldie(Highcharts);
exporting(Highcharts);

export default {
  components: { perturbationtable },
  data() {
    return {
      svgSrc: "",
      chart: "",
      //选择基因
      options: [],
      defaultGene: {
        SC00001: "JAK2",
        SC00002: "INTS15",
        SC00003: "RAD51",
        SC00004: "INTS15",
        SC00005: "HSPA9",
        SC00006: "MAPK1",
        SC00007: "ATF6",
        SC00008: "SPI1",
        SC00009: "AARS1",
        SC00010: "IFNGR1",
        SC00011: "IFNGR1",
        SC00012: "IFNGR1",
        SC00013: "IRF1",
        SC00014: "CNIH4",
        SC00015: "IFNAR1",
        SC00016: "ACE",
        SC00017: "NTRK2",
        SC00018: "ARID1A",
        SC00019: "JUN",
        SC00020: "TP53",
        SC00021: "TP53",
        SC00022: "SMARCB1",
        SC00023: "SMARCB1",
        SC00024: "SMARCB1",
        SC00025: "SMARCB1",
        SC00026: "SMARCB1",
        SC00027: "SMARCB1",
        SC00028: "SMARCB1",
        SC00029: "SMARCB1",
        SC00030: "SMARCB1",
        SC00031: "SMARCB1",
        SC00032: "SMARCB1",
        SC00033: "SMARCB1",
        SC00034: "SMARCB1",
        SC00035: "SMARCB1",
        SC00036: "SMARCB1",
        SC00037: "EXOSC5",
        SC00038: "IFNAR1",
        SC00039: "ASH2L",
        SC00040: "BICDL2",
        SC00041: "CARS1",
        SC00042: "MTOR",
        SC00043: "ATP6V1A",
        SC00044: "ETS2",
        SC00045: "ATP5F1E",
        SC00046: "ATP5F1E",
        SC00047: "CDX1",
        SC00048: "MESP1",
        SC00049: "ASCL1",
        SC00050: "NEUROG1",
        SC00051: "KLF4",
        SC00052: "LAMTOR1",
        SC00053: "LAMTOR1",
        SC00054: "LAMTOR1",
        SC00055: "LAMTOR1",
        SC00056: "SOD1",
        SC00057: "TGFBR2",
        SC00058: "MED14",
        SC00059: "KLF6",
        SC00060: "TCF4",
        SC00061: "GATA3",
        SC00062: "PTEN",
        SC00063: "ZAP70",
        SC00064: "SPTB",
        SC00065: "LAMTOR1",
        SC00066: "LAMTOR1",
      },
      value: "",
    };
  },
  name: "tcgaExpAll",
  props: {
    msg: String,
  },
  watch: {
    value() {
      // axios
      //   .get(
      //     "http://www.perturbdb.com/API/perturbedgene/publications_corNetwork.php",
      //     {
      //       params: {
      //         datasetId: this.$route.query.datasetId,
      //         gene: this.value,
      //       },
      //     }
      //   )
      //   .then((response) => {
      //     this.moreChart(response.data["data"], response.data["node"]);
      this.svgSrc =
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/cor_net/" +
        this.value +
        ".svg";
      // });
    },
  },
  mounted() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_corNetworkGenelist.php",
        {
          params: {
            datasetId: this.$route.query.datasetId,
          },
        }
      )
      .then((response) => {
        this.options = response.data.slice(0, 20);
        this.value = this.defaultGene[this.$route.query.datasetId];
        this.svgSrc =
          "http://research.gzsys.org.cn/perturbdb/data/publications/" +
          this.$route.query.datasetId +
          "/cor_net/" +
          this.value +
          ".svg";
      });
  },
  methods: {
    handleChange(value) {
      this.value = value;
    },
    handleSearch(value) {
      if (value == "") {
        this.options = [];
      } else {
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/publications_corNetworkGenelistResponse.php",
            {
              params: {
                datasetId: this.$route.query.datasetId,
                gene: value,
              },
            }
          )
          .then((response) => {
            this.options = response.data.slice(0, 20);
          });
      }
    },
    moreChart(datas, nodes) {
      if (this.chart) {
        this.chart.destroy();
      }
      // 初始化 Highcharts 图表
      this.chart = new Highcharts.chart("container", {
        //去掉水印
        credits: {
          enabled: false,
        },
        chart: {
          type: "networkgraph",
          // plotBorderWidth: 1,
          height: "90%",
        },
        title: {
          text: "",
        },
        // subtitle: {
        //   text: "Integration: " + "euler",
        // },
        plotOptions: {
          networkgraph: {
            layoutAlgorithm: {
              enableSimulation: true,
              integration: "verlet",
              linkLength: 0,
            },
            keys: ["from", "to"],
            marker: {
              radius: 10,
              lineWidth: 5,
            },
          },
        },
        // tooltip: {
        //   pointFormat: "haha",
        // },
        series: [
          {
            nodes: nodes,
            data: datas,
          },
        ],
      });
      //   plot done
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit css to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
